import React from 'react';
import { Col, ContentContainer, Row, Heading, SectionHeader,
    IconNotificationWarning } from '@snsw-gel/react';
import styles from './CardError.module.scss';

const CardErrorPage = () => {
    const replaceCardLink='https://www.service.nsw.gov.au/transaction/replace-a-lost-stolen-or-destroyed-nsw-seniors-card-or-nsw-senior-savers-card',
        convertCardLink='https://www.service.nsw.gov.au/transaction/convert-a-nsw-senior-savers-card-to-a-nsw-seniors-card',
        digitalCardLink='https://www.service.nsw.gov.au/transaction/get-a-digital-nsw-seniors-card-or-nsw-senior-savers-card';
    const replaceCardText='replace a lost, stolen or damaged card',
        convertCardText='convert a NSW Senior Savers Card to a NSW Seniors Card',
        digitalCardText='get a digital card';

    const internalLinkDatalayer = (linkText,positionId,destinationUrl)=>{
        window.dataLayer.push({
            'event':'component_interaction',
            'component_type':'link_internal',
            'component_text':linkText,
            'section_id':'page_content',
            'position_id': positionId,
            'destination_url': destinationUrl
        });
    };

    return (
        <>
            <SectionHeader className={ styles['heading-section'] }
                label='Apply for a NSW Seniors Card or NSW Senior Savers Card '>
                <Heading level={ 1 }>
                    <IconNotificationWarning className={ styles['error-icon'] }/>
                     A card already exists
                </Heading>
            </SectionHeader>

            <ContentContainer className={ styles['content-container'] }>
                <Row>
                    <Col span={ 9 }>
                        <p>A NSW Seniors or Senior Savers Card has already been added to your MyServiceNSW Account. You can:
                        </p>
                        <ul>
                            <li> <a target='_self'
                                onClick={ ()=>internalLinkDatalayer(replaceCardText,1,replaceCardLink) }
                                href={ replaceCardLink }>
                                {replaceCardText}
                            </a></li>
                            <li><a target='_self'
                                onClick={ ()=>internalLinkDatalayer(convertCardText,2,convertCardLink) }
                                href={ convertCardLink }>
                                {convertCardText}
                            </a></li>
                            <li> <a target='_self'
                                onClick={ ()=>internalLinkDatalayer(digitalCardText,3,digitalCardLink) }
                                href={ digitalCardLink }>
                                {digitalCardText}
                            </a>.</li>
                        </ul>
                        <p>If you have never applied for NSW Seniors or Senior Saver Card or need support, visit your nearest <a target='_self' href='https://www.service.nsw.gov.au/service-centre'> service centre</a> or call us on <a aria-label='Call us on 1 3 7 7 8 8'
                            href='tel:137788'>13 77 88</a>.</p>
                    </Col>
                </Row>
            </ContentContainer>
        </>
    );

};
export default CardErrorPage;
